import React, { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { HOMEPAGE } from '../../../router/routes';
import { useService } from '../../../services/services';
import GuestLayout from '../../../components/external/guest-layout';
import AuthButton from '../../../components/external/auth-button';
import authCss from '../auth-forms.module.css';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { email: '' },
  });
  const { authService } = useService();
  const [message, setMessage] = useState<string>(null);

  const submit = useCallback(
    (data: { email: string }) => {
      if (!data.email) {
        return;
      }

      authService.csrf().subscribe(() => {
        authService.forgotPassword(data.email).subscribe(
          () => {
            setMessage('components.modals.forgot_password_success.message');
            history.push({
              pathname: HOMEPAGE,
              search: `?message=forgot_password_success`,
            });
          },
          ({ response: { errors } }) => {
            let data: any = Object.values(errors)[0];
            setMessage(`pages.external.forgot-password.${data[0]}`);
          }
        );
      });
    },
    [history, authService, setMessage]
  );

  return (
    <GuestLayout>
      <div className={authCss['container']}>
        <form
          className={authCss['form']}
          onSubmit={handleSubmit(submit)}
          autoComplete="off"
        >
          <h1>{t('pages.external.forgot-password.title')}</h1>

          {message && <span className={authCss['error']}>{t(message)}</span>}

          <div className={authCss['field']}>
            <label htmlFor="email">
              {t('pages.external.forgot-password.email')}:
            </label>
            <input
              type="text"
              id="email"
              name="email"
              className={authCss['input']}
              {...register('email', { required: true })}
            />
          </div>

          <div className={authCss['buttons']}>
            <AuthButton
              label={t('pages.external.forgot-password.btn')}
              type="submit"
              disabled={!isValid}
            />
          </div>
        </form>
      </div>
    </GuestLayout>
  );
}
